<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <h2>{{ labelService.getLabel(title) }}</h2>

    <form [formGroup]="documentForm" class="document-form">
      @for (input of inputBoxes; track input) {
        @if (input.label !== "date" && input.label !== "category") {
          <mat-form-field appearance="fill">
            <mat-label>{{ labelService.getLabel(input.label) }}</mat-label>
            <input matInput [formControlName]="input.label" type="text" />
          </mat-form-field>
        }
        @if (input.label === "date") {
          <mat-form-field appearance="fill">
            <mat-label>{{ labelService.getLabel(input.label) }}</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              [formControlName]="input.label"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        }
      }

      @if (documentsCategories.length > 0) {
        <mat-form-field appearance="fill">
          <mat-label>{{ labelService.getLabel("category") }}</mat-label>
          <mat-select formControlName="category">
            @for (category of documentsCategories; track category) {
              <mat-option [value]="category">
                {{ category }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (!isEditing) {
        <div class="file-upload">
          <input
            type="file"
            (change)="onFileSelected($event)"
            accept=".pdf, .doc, .docx, .pages"
            #fileInput
            hidden
          />
          <div class="upload-container">
            <button
              class="button-white"
              mat-raised-button
              (click)="fileInput.click()"
            >
              <mat-icon>upload_file</mat-icon>
              {{ labelService.getLabel("Carica File") }}
            </button>
            @if (fileData) {
              <div class="file-info">
                <span class="filename">{{ fileData.name }}</span>
                <span class="file-size"
                  >({{ formatFileSize(fileData.size) }})</span
                >
                <button mat-icon-button (click)="removeFile()">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
      }
    </form>

    @if (showMessageError) {
      <mat-error>
        Popola tutti i campi e carica un file prima di confermare
      </mat-error>
    }

    @if (showErrorFileSize) {
      <mat-error> Il file caricato è superiore a 32MB. </mat-error>
    }

    <div class="panel-buttons">
      <button class="button-white" mat-stroked-button (click)="onCancel()">
        {{ labelService.getLabel("cancel") }}
      </button>
      <button
        class="button-white"
        mat-raised-button
        (click)="onConfirm()"
        [disabled]="isBtnClicked"
      >
        {{ labelService.getLabel("confirm") }}
      </button>
    </div>
  </div>
</div>
